export { default } from './svg/close.svg';
